import type { InboxReminder } from 'owa-graph-schema';

const getReminderFollowUpCount = (inboxReminders: InboxReminder[]) => {
    // Counting no. of follow-ups
    const inboxFollowUpCount = inboxReminders.filter(
        reminder => Number(reminder.ReminderOffset) < 0
    ).length;

    // Counting no. of reminders
    const inboxReminderCount = inboxReminders.length - inboxFollowUpCount;

    return { inboxReminderCount, inboxFollowUpCount };
};

export default getReminderFollowUpCount;
